<div class="app-container">
    <!-- HEADER -->
    <global-header></global-header>
    <!-- uncomment HTML block below if we want to display a global notification -->
    <!--
    <div *ngIf="persistentDatabase.isGlobalNotificationVisible"
        class="bk-notification-global">
        <i class="fa fa-close" (click)="dismissGlobalNotification()"></i>
        <h2>Donate to Sustain CropManage</h2>
        <p>
            We need your help to maintain and improve CropManage.
            We are constantly fixing bugs and adding new features.  Hosting CropManage on a professional cloud server and
            storing user data also has fixed costs.
            Through grants, UC Cooperative Extension has paid these expenses as well as the salary of a full-time professional
            software engineer who keeps CropManage running smoothly and adds new capabilities and features.
            While we will continue to seek out new grant opportunities, your donation can help offset the costs
            of operating CropManage and to assure that this valuable online tool is sustained into the future.
        </p>
        <p>If you have found CropManage to be a valuable service for your farming operation or company, please consider donating.
            Just <a href="{{ donationLink }}" target="_blank">click here</a> to donate.</p>
    </div>
    -->
    <ng-container *ngIf="!isAuthenticated; else memberLayout">
        <div class="cm-landing-body-wrapper">
            <router-outlet></router-outlet>
            <div class="bk-clearfix"></div>
            <footer-public></footer-public>
        </div>
    </ng-container>

    <ng-template #memberLayout>
        <router-outlet></router-outlet>
    </ng-template>

</div>
